import {ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {EmojiEvent} from "@ctrl/ngx-emoji-mart/ngx-emoji";
import {MatMenuModule, MatMenuTrigger} from "@angular/material/menu";
import {LiveAnnouncer} from "@angular/cdk/a11y";
import {MatIconModule} from "@angular/material/icon";
import {PickerModule} from "@ctrl/ngx-emoji-mart";
import {MatButtonModule} from "@angular/material/button";

@Component({
    selector: 'app-emoji-menu',
    templateUrl: './emoji-menu.component.html',
    styleUrl: './emoji-menu.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatMenuModule, MatIconModule, PickerModule, MatButtonModule]
})
export class EmojiMenuComponent {
    @Input() input: string | null = null;
    @Input() form: FormGroup | null = null;
    @Output() setEmoji: EventEmitter<string> = new EventEmitter<string>();

    constructor(private liveAnnouncer: LiveAnnouncer, private elementRef: ElementRef) {
    }

    addEmoji(event: EmojiEvent, menuItem: MatMenuTrigger): void {
        menuItem.closeMenu()
        if (this.input && this.form) {
            let value: string | undefined = event.emoji.native;
            if (this.form.value[this.input]) {
                value = this.form.value[this.input] + event.emoji.native;
            }
            this.form.controls[this.input]?.setValue(value);
        } else {
            this.setEmoji.emit(event.emoji.native)
        }

        // Focus back on the input/textarea field
        setTimeout(() => {
            let el: HTMLElement | null = null;
            if (this.input) {
                el = document.querySelector(`[formControlName="${this.input}"]`) as HTMLElement;
            }
            if (!el) {
                const parentField = this.elementRef.nativeElement.closest('.mat-mdc-form-field');
                if (parentField) {
                    el = parentField.querySelector('input, textarea') as HTMLElement;
                }
            }
            if (el) {
                el.focus();
            }
        });

        const emojiName = event.emoji.name || 'emoji';
        this.liveAnnouncer.announce(`Emoji ${emojiName} inserted`).then();
    }

    stopClose(event: Event | KeyboardEvent): void {
        event.stopPropagation()
    }
}
